/***
 * 创建人：李珊
 * 时间：2020-11-27
 * 描述: 素材资源管理
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { SwGridTableComponent } from '../../../../../librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwMassageConfirmComponent } from '../../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { Router, ActivatedRoute } from '@angular/router';
import { KmsService } from '../../../kms.service';
import { KmsEnum } from '../../../serves/kms-enum';
import { MaterialAddComponent } from '../material-add/material-add.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { PlatformLocation } from '@angular/common';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { environment } from 'src/environments/environment';
import { CatalogueAddorupComponent } from '../catalogue-addorup/catalogue-addorup.component';
import { KmsFileUploaderBoxComponent } from '../../../components/kms-file-uploader/kms-file-uploader-box/kms-file-uploader-box.component';
import { MaterialViewComponent } from '../material-view/material-view.component';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
declare var $;
@Component({
  selector: 'app-material-query',
  templateUrl: './material-query.component.html',
  styleUrls: ['./material-query.component.css']
})
export class MaterialQueryComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;    
  @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认删除弹框
  // 素材名称
  materialTitle: string = '';
  // 文字提取状态
  textExtractStatus:any = null;
  statusOptions:any = [
    {id:0,text:'未提取'},
    {id:4,text:'待提取'},
    {id:1,text:'提取中'},
    {id:2,text:'提取失败'},
    {id:3,text:'已提取'},
  ];
  accessTypeOptions:any = [
    {id:1,text:'文件导入'},
    {id:2,text:'网络抓取'},
    {id:3,text:'人工录入'}
  ];
  // 资源类型选项
  materialCategory = "FILE_TYPE_ALL";
  fileCategoryOptions = [{ id: "FILE_TYPE_ALL", text: "全部" }];
  fileCategoryOptions1 = [];
  docTypeOptions:any = KmsEnum.docTypeOptions;
  // 是否显示正在加载
  isLoading = false;
  datas: any = [];
  //  表格选中行数据
  selectData: any = [];
  // 分页参数
  pageBase: any = {
    current: 1,
    size: 10
  };
  // 表格操作按钮
  toolbarArr = [
      ["import","add","batchParse","batchDelete"],
      ["modify", "view", "delete", "parse","knowledgeExtract","download"],
  ];
  toolbar = [[], []];
  menuToolbar = ['addCatalogue', 'modifyCatalogue', 'deleteCatalogue'];
  // 用户角色
  userRole = '';
  // 是否查看大图
  showBigImg = false;
  filePath = '';
  // 是否展示左侧菜单
  showLeft: boolean = true;
  // 左侧目录树数据
  keyword = ''; // 目录筛选条件
  menuDatas: any = [];
  // 是否正在加载左侧目录树
  isLoadingMenus = false;
  // 当前选中的目录
  selectedMenu: any = null;
  selectedMenuParents = [];
  // 当前知识库绑定的模型版本id
  modelVerId = '';
  constructor(
    private instanceModuleService: InstanceModuleService,
    private location: PlatformLocation,
    private jwt: SwJwtService,
    private http: SwHttpClientService,
    private box: SwMassageBoxService,
    private kmsService: KmsService, 
    private router: Router,
    private create: SwCreateModalComponentService) {
  }

  ngOnInit() {
    // 获取模型版本id
    let kgDbInfo = this.jwt.getToken('kgDbInfo') ? JSON.parse(this.jwt.getToken('kgDbInfo')) : '';
    this.modelVerId = kgDbInfo && kgDbInfo.modelVerId ? kgDbInfo.modelVerId : '';
    // 获取用户角色
    this.userRole = this.jwt.getToken('userRole');
    // 资源类型数据
    const fileTypes = this.instanceModuleService.getResourceTypeOptions();
    this.fileCategoryOptions = this.fileCategoryOptions.concat(fileTypes);
    // 把所有外站链接类型的合并成外站链接一个选项
    this.fileCategoryOptions1 = JSON.parse(JSON.stringify(KmsEnum.fileTypes));
    this.fileCategoryOptions1.unshift({ id: "FILE_TYPE_ALL", text: "全部" });

    // 查询工具按钮列表
    this.queryToolbarBtns(); 
    // 表格数据初始化
    this.handleSelectClick();
    // 查询全部的资源云目录信息
    this.queryAllCatalogues();
  }

  // 监听输入框enter键搜索
  handelEnterSearch(event) {
    if (event.keyCode == 13) {
      this.handleSelectClick();
    }
  }

  // 查询工具按钮列表
  queryToolbarBtns() {
    // 根据路径去查询配置的按钮
    let pathname = ["/", "", ""]
    try {
        pathname = this.location["location"].hash.split('?')[0].split("/");
    } catch (e) {

    }
    let systemId = this.jwt.getToken("systemId")
    // 准备拼接url
    let url = environment.seekerWebAPI + "function/queryButtonsByUri"
    // 要去掉#，故第一个参数不使用
    if (pathname.length > 1) {
        // 拼接uri
        url = url + "?uri=";
        for (let index = 1; index < pathname.length; index++) {
            url = url + "/" + pathname[index]
        }
    }
    // 拼接系统ID参数
    url = url + "&systemId=" + systemId;
    this.http.Post(url, {}).subscribe(data => {
        if (data.code == '200') {
            data.data.forEach((element) => {
                if (
                    this.toolbarArr[0].filter((item) => item == element.functionCode)
                        .length > 0
                ) {
                    this.toolbar[0].push({
                        status: true,
                        functionCode: element.functionCode,
                        functionName: element.functionName,
                        icon: element.icon,
                        children: [],
                    });
                }
                if (
                    this.toolbarArr[1].filter((item) => item == element.functionCode)
                        .length > 0
                ) {
                    this.toolbar[1].push({
                        status: true,
                        functionCode: element.functionCode,
                        functionName: element.functionName,
                        icon: element.icon,
                        children: [],
                    });
                }
            });
        } else {
            this.box.waring('当前用户按钮组权限获取失败！');
        }
    });
  }

  // 监听页面滚动事件，将表格按钮组模块置顶
  listenScroll(event) {
    if (event.srcElement.scrollTop > $('.exploring-select-query').height()) {
      $('.scrollContainer .sw-toolbar').addClass('fixTop');
    } else {
      $('.scrollContainer .sw-toolbar').removeClass('fixTop');
    }
  }

  // 查询方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  // 重置按钮事件方法
  handleReloadClick() {
    this.materialTitle = '';
    this.textExtractStatus = null;
    this.materialCategory = 'FILE_TYPE_ALL';
    this.selectedMenu = null;
    this.selectedMenuParents = [];
    this.pageBase = {
      current: 1,
      size: 10,
    };
    this.getData();
  }

  //获取资源列表
  getData() {
    this.isLoading = true;
    let params = {
      current: this.pageBase.current,
      size: this.pageBase.size,
      materialTitle: this.materialTitle,
      textExtractStatus: this.textExtractStatus,
      materialCategory: this.materialCategory == 'FILE_TYPE_ALL' ? '' : this.materialCategory,
      catalogId: this.selectedMenu ? this.selectedMenu.catalogId : ''
    }
    this.kmsService.queryMaterialList(params).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.pageBase = data.data;
          let res = data.data.records ? data.data.records : [];
          this.datas = [];
          res.forEach((item) => {
            const item1 = this.instanceModuleService.getResourceThumbnail(item,this.fileCategoryOptions);
            this.datas.push(item1);
          });
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  //  表格选择数据
  outSelectData(event) {
    //获取当前选中的所有数据
    this.selectData = event;
    //设置表格按钮组状态
    this.swtable.toolbarAllEnable();
    if (this.selectData.length == 0) {
      this.swtable.toolbarDisable("batchParse");
      this.swtable.toolbarDisable("batchDelete");
    }else{
      let items = this.selectData.filter(el => el.textExtractStatus == 1 || ((el.materialCategory != 'FILE_TYPE_PICTURE' && el.materialCategory != 'FILE_TYPE_DOCUMENT')));
      if(items.length>0){
        this.swtable.toolbarDisable("batchParse");
      }

      let items1 = this.selectData.filter(el => el.textExtractStatus == 1 || el.textExtractStatus == 4);
      if(items1.length>0){
        this.swtable.toolbarDisable("batchDelete");
      }
    };
  }

  // 按钮点击事件
  onOperation(event) {
    switch (event) {
      // 导入
      case 'import':
        this.upload();
        break;
      // 新增
      case 'add':
        this.clickAdd();
        break;
      // 批量解析
      case 'batchParse':
        this.clickBatchParse();
        break;
      // 批量删除
      case 'batchDelete':
        this.clickDelete();
        break;
    }
  }

  // 素材新增
  clickAdd(){
    let param = { "upOrAdd": "Add", "selectedData": null };
    this.create.createModal(MaterialAddComponent, param, this.handleSelectClick.bind(this));
  }

  /**
   * 工具栏点击事件--上传文件
   * @ignore
   */
  upload() {
    // 通过知识库标识拼接文件策略
    let kgDbInfo = JSON.parse(this.jwt.getToken("kgDbInfo"));
    let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : "";
    let fileCode = kgCode
      ? KmsEnum.KMS_INSTANCE_RESOURCE + "_" + kgCode.toUpperCase()
      : "";

    let uploadParams = {
      label3: "filePicker", //根据 label3 确定上传组件的 id
      fileCode: fileCode, //根据 fileCode 查询策略
      fileBusinessId: "", //根据 fileCode 和 fileBusinessId 查询已上传文件,如果此值为空，就根据下面的 fileInfoIds 来查
      fileInfoIds: [], //根据 fileInfoIds 也可以查询已上传文件
      closeDisabled: true, //根据此值决定上传模态框中右上角的 × 是否消失
      isUploadResource: true,  //是否上传资源
      catalogId: this.selectedMenu ? this.selectedMenu.catalogId : ''
    };
    this.create.createModal(
      KmsFileUploaderBoxComponent,
      uploadParams,
      this.uploadCallback.bind(this)
    );
  }

  /**
   * 上传完成后的回调
   * @ignore
   */
  uploadCallback(event) {
    // event.addList 需保存的资源信息； event.instanceInfo 需关联的实体信息
    let files = event.list.addList;
    let resourceParams = event.resourceParams ? event.resourceParams : {};
    if (files) {
      let params = [];
      files.forEach((element) => {
        let thumbnailPath = "";
        if (element.fileType == "FILE_TYPE_PICTURE") {
          let index = element.fileName.lastIndexOf(".");
          let name =
            element.fileName.substring(0, index) +
            "_300@x." +
            element.fileSuffix;
          thumbnailPath = element.filePath + "THUMB/" + name;
        }
        let arr = element.fileOldname.split(".");
        let fileName = "";
        for (let i = 0; i < arr.length - 1; i++) {
          if (i == arr.length - 2) {
            fileName += arr[i];
          } else {
            fileName += arr[i] + ".";
          }
        }
        let category = this.isNotTiff(element.fileName)
          ? element.fileType
          : "FILE_TYPE_PICTURE";
        let entity = {
          fileId: element.fileInfoId,
          fileSuffix: element.fileSuffix,
          materialTitle: fileName,
          filePath: element.filePath + element.fileName,
          materialCategory: category,
          fileThumbnail: thumbnailPath,
          accessType: 1,
          approvalStatus: 0,
          currentUserRole: this.userRole == '知识编辑' ? 1 : 2,
          status: 0,
          textExtractStatus: 0,
          catalogId: resourceParams.catalogId,
          docType: resourceParams.docType,
        };
        params.push(entity);
      });
      // 保存资源信息
      this.kmsService.saveOrUpdateMaterial(params).subscribe((data) => {
        if (data.code == "200") {
          this.box.success("保存成功！");
          this.updateESMaterialInfo(data.data);
          this.handleSelectClick();
        } else {
          this.box.waring(data.msg);
        }
      });
    }
  }

  // 更新资源es信息
  updateESMaterialInfo(ids){
    if(ids.length == 0){
        return;
    }
    this.kmsService.updateESMaterialInfo({"materialIdList":ids}).subscribe(
      data => {
        if (data["code"] != 200) {
          this.box.danger(data.msg);
        }
      }
    )
  }

  // 批量解析
  clickBatchParse() {
    if (this.selectData.length == 0) {
      this.box.danger('请至少选择一条数据！');
      return;
    }
    let ids = [];
    this.selectData.forEach(item => {
      ids.push(item.materialId);
    });
    this.sureParse(ids);
  }

  // 批量删除
  clickDelete() {
    if (this.selectData.length == 0) {
      this.box.danger('请至少选择一条数据！');
      return;
    }
    let ids = [];
    this.selectData.forEach(item => {
      ids.push(item.materialId);
    });
    this.delete(ids);
  }

  isNotTiff(path) {
    if (path && (path.indexOf(".tif") >= 0 || path.indexOf(".tiff") >= 0)) {
      return false;
    } else {
      return true;
    }
  }

  /**
  * 点击td中的按钮
  * @ignore
  */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 编辑
    if (type == 'modify') {
      let param = { "upOrAdd": "Edit", "selectedData": data };
      this.create.createModal(MaterialAddComponent, param, this.getData.bind(this));
    }
    // 删除
    else if (type == 'delete') {
      this.delete([data.materialId]);
    }
    // 查看
    else if (type == 'view') {
      let param = { "upOrAdd": "View", "selectedData": data };
      this.create.createModal(MaterialViewComponent, param, this.getData.bind(this));
    }
    // 解析
    else if(type == 'parse'){
      this.sureParse([data.materialId]);
    }
    // 知识提取
    else if(type == 'knowledgeExtract'){
      let params = {
        materialId: data.materialId,
        keyword: ''
      };
      this.router.navigate(['/kms/KnowledgeExtract'], {queryParams: {Title: '素材浏览', selectData: JSON.stringify(params)}});
    }
    // 下载
    else if(type == 'download'){
      const url = environment.staticFileUrl + data.filePath;
      const fileName = data.materialTitle;
      const fileSuffix = url.split('.').pop().toLocaleLowerCase();
      this.downloadFile(url, fileName+'.'+fileSuffix);
    }
  }

  // 点击删除
  delete(ids) {
    // 需先判断是否存在来源为该素材的实体，若存在给出提示“存在来源为该素材的实体,不允许进行删除！”
    this.trim.openCLick("确认删除吗？", (data) => {
      if (data) {
        this.deleteEs(ids);
      }
    })
  }

  // 删除资源es信息
  deleteEs(ids){
    // 删除es信息
    this.kmsService.deleteESMaterialInfo({"materialIdList":ids}).subscribe(
      data => {
        if (data["code"] != 200) {
          this.box.danger(data.msg);
        }else{
          this.kmsService.deleteMaterialById(ids).subscribe(
            data => {
              if (data["code"] == '200') {
                this.box.success("操作成功");
                this.getData();
              } else {
                this.box.waring(data.msg);
              }
            }
          )
        }
      }
    )
  }

  // 分页点击方法
  clickPageQuery(event) {
    this.pageBase['pageNum'] = event.current;
    this.pageBase['pageSize'] = event.size;
    this.getData();
  }

  // 选择文件类型
  selectCategory(item){
    this.materialCategory = item.id;
    this.handleSelectClick();
  }

  // 获取文件类型名称
  getCategoryName(id) {
    let items = this.fileCategoryOptions.filter((item) => item.id === id);
    return items.length > 0 ? items[0].text : "其他";
  }

  // 获取排版格式
  getDocType(data){
    const id = data.docType ? data.docType : '';
    let items = this.docTypeOptions.filter((item) => item.id === id);
    return items.length > 0 ? items[0].text : "无";
  }

  // 获取素材获取方式名称
  getAccessTypeName(id) {
    let items = this.accessTypeOptions.filter((item) => item.id === id);
    return items.length > 0 ? items[0].text : "无";
  }

  // 判断操作按钮是否禁用
  isDisable(item,data){
    // 启用、禁用解析按钮
    if(item.functionCode == 'parse'){
      // 文字提取状态为提取中；素材类型为非图像、非文档时需禁用解析按钮
      if((data.fileSuffix && data.fileSuffix.toLowerCase() !== 'pdf') || data.textExtractStatus === 1 || data.textExtractStatus === 4 || (data.materialCategory !== 'FILE_TYPE_PICTURE' && data.materialCategory !== 'FILE_TYPE_DOCUMENT')){
        return true;
      }else{
        return false;
      }
    }
    // 启用、禁用知识提取按钮
    if(item.functionCode == 'knowledgeExtract'){
      // 文字提取状态不是已提取 或 素材类型为非图像、非文档时需禁用知识提取按钮
      if(data.textExtractStatus !== 3 || (data.materialCategory !== 'FILE_TYPE_PICTURE' && data.materialCategory !== 'FILE_TYPE_DOCUMENT')){
        return true;
      }else{
        return false;
      }
    }
    // 启用、禁用下载按钮
    if(item.functionCode == 'download'){
      // 资源类型为链接时需禁用下载按钮
      if(!data.materialCategory || data.materialCategory.indexOf('KGS_LINKDATA')>-1 || !data.filePath){
        return true;
      }else{
        return false;
      }
    }
    // 启用、禁用删除按钮
    if(item.functionCode == 'delete'){
      // 文字提取状态为待提取或提取中时需禁用删除按钮
      if(data.textExtractStatus === 1 || data.textExtractStatus === 4){
        return true;
      }else{
        return false;
      }
    }
    return false;
  }

  // 确认解析操作
  sureParse(ids){
    this.trim.openCLick("确认对当前选中的资源进行ocr文字识别吗？", (data) => {
      if (data) {
        // 执行文字识别操作
        this.kmsService.resourceOcrByIds(ids).subscribe(
          data => {
            if (data["code"] == '200') {
              this.box.success("操作成功");
              this.getData();
            } else {
              this.box.waring(data.msg);
            }
          }
        )
      }
    })
  }

  // 查看大图
  viewBigImg(data){
    // 图片
    if (data.materialCategory == 'FILE_TYPE_PICTURE'){
      this.showBigImg = true;
      this.filePath = data.filePath;
    }
    // 已解析文档
    else if(data.textExtractStatus === 3 && data.materialCategory === 'FILE_TYPE_DOCUMENT'){
      let params = {
        materialId: data.materialId,
        keyword: ''
      };
      this.router.navigate(['/kms/KnowledgeExtract'], {queryParams: {Title: '素材浏览', selectData: JSON.stringify(params)}});
    }else{
      this.box.info('很抱歉，当前文件不支持预览！');
    }
  }

  // 左侧目录树切换显示或隐藏
  showStyle(data) {
    this.showLeft = !data;
  }

  // 点击选中左侧的某个资源云目录
  handleVotedClick(event) {
    // 当前点击的是模型名称
    this.selectedMenu = event.data;
    let mappingArr = event.data.mapping.split(',');
    this.selectedMenuParents = [];
    mappingArr.forEach(e => {
      let item = this.menuDatas.find(e1 => e1.catalogId == e);
      if (item) {
        this.selectedMenuParents.push(item);
      }
    });
    // 触发查询
    this.handleSelectClick();
  }

  // 查询所有的资源云目录信息
  queryAllCatalogues() {
    this.isLoadingMenus = true;
    this.kmsService.queryAllCatalog().subscribe(
      res => {
        this.isLoadingMenus = false;
        if (res.code == 200) {
          this.menuDatas = res.data;
          this.menuDatas = this.menuDatas.sort((a, b) => { return a.sortNum - b.sortNum });
          this.menuDatas.forEach(e => {
            e.id = e.catalogId;
            e.text = e.catalogName;
            e.pid = e.parentId;
          });
          if(this.menuDatas.length == 0){
            let kgDbInfo = JSON.parse(this.jwt.getToken('kgDbInfo'));
            let kbId = kgDbInfo && kgDbInfo.kgDbId ? kgDbInfo.kgDbId : '';
            if(kbId){
              this.createRootCatalogue(kbId);
            }
          }
        }
      }
    )
  }

  // 资源云目录操作
  menuToolClick(state) {
    switch (state) {
      case 'add': {
        let param = { "upOrAdd": "Add", "selectedData": null };
        this.create.createModal(CatalogueAddorupComponent, param, this.queryAllCatalogues.bind(this));
        break;
      }
      case 'edit': {
        if (!this.selectedMenu) {
          this.box.info('请选择一个资源云目录！');
          return;
        }
        if (this.selectedMenu.parentId == 'root') {
          this.box.info('根目录不允许编辑！');
          return;
        }
        let param = { "upOrAdd": "Edit", "selectedData": this.selectedMenu };
        this.create.createModal(CatalogueAddorupComponent, param, this.queryAllCatalogues.bind(this));
        break;
      }
      case 'delete': {
        if (!this.selectedMenu) {
          this.box.info('请选择一个资源云目录！');
          return;
        }
        if (this.selectedMenu.parentId == 'root') {
          this.box.info('根目录不允许删除！');
          return;
        }
        let item = this.menuDatas.find(e1 => e1.parentId == this.selectedMenu.catalogId);
        if (item) {
          this.box.info('该目录下存在子文件夹，不允许删除！');
          return;
        }

        this.trim.openCLick("确认删除该资源云目录吗？", (data) => {
          if (data) {
            this.kmsService.deleteRmsCatalogById(this.selectedMenu.catalogId).subscribe(
              data => {
                if (data["code"] == '200') {
                  this.box.success("操作成功");
                  const rootMenu = this.menuDatas.find(e => e.parentId == 'root');
                  if(rootMenu){
                    this.handleVotedClick({data:rootMenu});
                  }
                  this.queryAllCatalogues();
                } else {
                  this.box.waring(data.msg);
                }
              }
            )
          }
        });
        break;
      }
    }
  }

  // 默认生成一条根目录信息
  createRootCatalogue(kbId){
    const id = this.instanceModuleService.uuid2();
    let params = {
      "catalogId": id,
      "catalogName": "根节点",
      "parentId": "root",
      "catalogLevel": 1,
      "mapping": id,
      "sortNum": 0,
      "kbId": kbId
    }
    this.kmsService.saveRmsCatalogObj(params).subscribe(
      res => {
        if(res.code !== 200){
          this.box.waring(res.msg);
        }
      }
    )
  }

  // 清除左侧目录树选中项
  clearTreeSelect() {
    this.selectedMenu = null;
    this.selectedMenuParents = [];
    this.handleSelectClick();
  }

  // 根据目录id，获取所有父级目录名称，并拼接成字符串
  getCatalogNamStr(catalogId){
    let str = '';
    const c = this.menuDatas.find(e => e.catalogId == catalogId);
    if(c){
      let mappingArr = c.mapping.split(',');
      let arr = [];
      mappingArr.forEach((v,i) => {
        let item = this.menuDatas.find(e1 => e1.catalogId == v);
        if (item) {
          arr.push(item);
        }
      });
      arr.forEach((v,i) => {
        str += (i == 0 ? v.catalogName : '/'+v.catalogName)
      })
    }
    return str;
  }

  /**
   * 根据完整文件路径下载文件（支持图片、PDF、Word、Excel、TXT等）
   * @param {string} filePath - 文件完整路径或URL
   * @param {string} [customFileName] - 自定义下载文件名（可选）
   * @returns {Promise<void>} - 下载完成后resolve
   */
  async downloadFile(filePath, customFileName = null) {
    try {
        // 提取文件名和扩展名
        const fileName = customFileName || filePath.split('/').pop();
        this.box.info("已在后台创建下载任务，请稍等...");
        // 发送HTTP请求获取文件
        const response = await fetch(filePath);
        
        if (!response.ok) {
            this.box.waring('下载失败！');
            throw new Error(`下载失败: ${response.status} ${response.statusText}`);
        }

        // 确保响应是视频类型
        const contentType = response.headers.get('content-type');
        
        // 获取文件大小用于进度计算
        const contentLength = response.headers.get('content-length');
        const totalSize = contentLength ? parseInt(contentLength, 10) : null;
        
        // 读取响应体并跟踪进度
        const reader = response.body.getReader();
        const chunks = [];
        let loaded = 0;
        
        while (true) {
            const { done, value } = await reader.read();
            if (done) {
                break;
            }
            chunks.push(value);
            loaded += value.length;
        }
        
        // 合并所有块并创建 Blob
        const blob = new Blob(chunks, { type: contentType });
        
        // 创建下载链接
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = customFileName;
        
        // 模拟点击下载
        document.body.appendChild(a);
        a.click();
        
        // 清理资源
        setTimeout(() => {
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }, 100);
    } catch (error) {
        this.box.waring('下载出错:'+error);
        throw error;
    }
  }
}


